import { render, staticRenderFns } from "./listFeederPillar.vue?vue&type=template&id=453a6fdb&scoped=true&"
import script from "./listFeederPillar.vue?vue&type=script&lang=js&"
export * from "./listFeederPillar.vue?vue&type=script&lang=js&"
import style0 from "./listFeederPillar.vue?vue&type=style&index=0&id=453a6fdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a6fdb",
  null
  
)

export default component.exports